import React, { useState, useMemo, useCallback } from "react"
import { graphql, useStaticQuery } from 'gatsby'
import { FormattedMessage, injectIntl } from 'react-intl'
import Img from 'gatsby-image'
import { Link } from './localizedlink'
import { slugify, findLocalized, filterLocalizedField } from '../utils'
import { inlineLexer } from 'marked'
import useAvatar from '../utility/useAvatar'
import User from '../images/svg-icons/user-light.svg'
import ICONS from '../utility/programma-icons'


const InterventoContent = ({ intervento }) => {
  const avatar = useAvatar();
  return (
    <>
      {intervento.speakers ? intervento.speakers.map((speaker, i) => (
        speaker.imageFile ? (
          <Img fixed={speaker.imageFile.childImageSharp.fixed} alt={intervento.relatore} className="speech__img" key={i} />
        ) : (
          // <Img fixed={avatar.childImageSharp.fixed} alt={intervento.relatore || 'To be defined'} className="speech__img" />
          <div className="speech__img-wrapper" key={i}>
            <User aria-label="avatar" />
            <img src={avatar.publicURL} alt={'To be defined'} className="speech__img" />
          </div>
        )
      )) : (
        <div className="speech__img-wrapper">
          <User aria-label="avatar" />
          <img src={avatar.publicURL} alt={'To be defined'} className="speech__img" />
        </div>
      )}
      <span className="speech__icon"><span></span></span>
      <span className="speech__name">{intervento.relatore}</span>
      <span className="event__title">{intervento.title || 'To be defined'}</span>
      <span className="speech__role">{intervento.tipologia}</span>
    </>
  )
};
const Intervento = ({ intervento }) => {
  return (
    <>
      {intervento.pageslug ? (
        <Link to={`/${intervento.pageslug}/`} title={`${intervento.title}`} className={`speech ${slugify(intervento.tipologia)}${intervento.speakers?.length > 1 ? ' speech--double' : ''}`} activeClassName="selected">
          <InterventoContent intervento={intervento} />
        </Link>
      ) : (
        <div className={`speech ${slugify(intervento.tipologia)}${intervento.speakers?.length > 1 ? ' speech--double' : ''}`}>
          <InterventoContent intervento={intervento} />
        </div>
      )}
    </>
  )
};

const Activity = ({ activity }) => {
  return (
    <>
      {activity.pageslug && 
        <Link to={`/${activity.pageslug}/`} title={`${activity.title}`} className="event__link">
          <span className="d-flex">
            {activity.icon && <span className="event__icon">{ICONS[activity.icon]}</span>}
            <span className="label">{activity.label}</span>
          </span>
        </Link>
      }
    </>
  )
};

const Event = ({ event, interventi, activity }) => (
  <div className="event" data-aos="fade-up">
    <div className="row">
      <div className="col-sm-2 col-md-1">
        <div className="event__hours">{event.hour}</div>
      </div>
      {event.icon && (
        <div className="col-sm-5 d-flex">
          {event.activity?
            <Activity activity={activity.find(item => item.slugId === event.activity)} />:
            <>
              {event.icon && <span className="event__icon">{ICONS[event.icon]}</span>}
              <div className="icon" dangerouslySetInnerHTML={{ __html: inlineLexer(event.label, []) }}></div>
            </>
          }
        </div>
      )}
      {event.intervento && (
        <div className="col-sm-10 col-md-11">
          <Intervento intervento={interventi.find(item => item.slugId === event.intervento)} />
        </div>
      )}
      {event.interventi && (
        <div className="col-sm-10 col-md-11">
          <div className="row">
            {event.interventi.map((intervento, i) => (
              <div className={`${i === 2 ? `col-sm-12` : `col-sm-6`}`} key={i}>
                <Intervento intervento={interventi.find(item => item.slugId === intervento)} />
              </div>
            ))}
          </div>
        </div>
      )}
      {/* {event.speaker && (
        <div className="col-sm-7">
          <span className="event__speaker">{event.speaker}</span> 
        </div>
      )} */}
    </div>
  </div>
);

const Programma  = ({ initialDay, intl: { locale} }) => {
  // console.log('initialDay: ', initialDay);

  const [tab, setTab] = useState(initialDay && initialDay.includes('23') ? 1 : 0);
  const data = useStaticQuery(graphql`
    query {
      programma: allProgrammaYaml{
        edges{
          node{
            day1{
              label
              hour
              icon
              intervento
              interventi
              speaker
              activity
            }
            day2{
              label
              hour
              icon
              intervento
              interventi
            }
            disclaimer_start
            disclaimer_end
            lang
          }
        }
      }
      interventi: allInterventiYaml{
        edges {
          node {
            title
            tipologia
            img
            speakers{
              title
              imageFile{
                childImageSharp{
                  fixed(width: 65, height: 65, quality: 100){
                    ...GatsbyImageSharpFixed_withWebp
                  }
                }
              }
            }
            pageslug
            relatore
            relatori
            slugId
            orario
            lang
          }
        }
      }
      activity: allActivityYaml {
        edges {
          node {
            title
            tipologia
            pageslug
            slugId
            orario
            icon
            label
            lang
          }
        }
      }
    }
  `);
  const { day1, day2, disclaimer_start } = useMemo(() => findLocalized(data.programma, locale), [data.programma, locale]);
  const interventi = useMemo(() => filterLocalizedField(data.interventi, locale), [data.interventi, locale]);
  const activity = useMemo(() => filterLocalizedField(data.activity, locale), [data.activity, locale]);
  const selectTab = useCallback((e, i) => {
    e.preventDefault();
    setTab(i);
  }, []);
  return (
    <section id="programma" className="section programma text-center" aria-labelledby="programma">
      <div className="container">

        <div className="row">
          <div className="col-sm-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
            <h1 id="region3" className="section__title">
              <FormattedMessage id="programma" />
            </h1>
            
            <div className="programma__disclaimer" dangerouslySetInnerHTML={{ __html: inlineLexer(disclaimer_start, []) }}></div>

            <div className="programma__btn">
              <a href="/" title="Guarda il programma del 19 maggio" className={tab === 0 ? 'active' : ''} itemProp="startDate" content="2020-10-22T09:15" onClick={(e) => selectTab(e, 0)}>
                <FormattedMessage id="day-1" defaultMessage="19 maggio" />
              </a>
              <a href="/" title="Guarda il programma del 20 maggio" className={tab === 1 ? 'active' : ''} itemProp="endDate" content="2020-10-23T09:00" onClick={(e) => selectTab(e, 1)}>
                <FormattedMessage id="day-2" defaultMessage="20 maggio" />
              </a>
            </div>

            {tab === 0 ? (
              <div id="day1" className="">
                {day1.map((event, i) => <Event event={event} interventi={interventi} activity={activity} key={i}/>)}
              </div>
            ) : (
              <div id="day2" className="">
                {day2.map((event, i) => <Event event={event} interventi={interventi} activity={activity} key={i}/>)}
              </div>
            )}
          </div>
        </div>
        {/* <div className="row" data-aos="fade-up">
          <div className="col-sm-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2 mt-5 text-center">
            <div className="programma__disclaimer" dangerouslySetInnerHTML={{ __html: marked(disclaimer_end) }}>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default injectIntl(Programma);